<template>
  <el-container id="customer-report">
    <el-aside width="260px">
      <div class="el-tabs el-tabs--left" style="height:500px;">
        <div class="el-tabs__header is-left">
          <div class="el-tabs__nav-wrap is-left">
            <div class="el-tabs__nav-scroll">
              <div role="tablist" class="el-tabs__nav is-left" style="transform: translateY(0px);">
                <div
                  class="el-tabs__active-bar is-left"
                  :style="{ height: '40px', transform: `translateY(${activeBarHeight}px)` }"
                ></div>
                <div
                  v-for="tab in tabs"
                  :key="tab.path"
                  :class="['el-tabs__item', 'is-left', $route.path.indexOf(tab.path) > 0 ? 'is-active' : '']"
                  @click="goPath(tab.path)"
                >{{ tab.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-aside>
    <el-main class="main" style="padding:0;background-color:#eee;">
      <router-view/>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
      tabs: [
        { path: "/new-company-report", title: "New company report" },
        { path: "/new-transaction-customer-report", title: "New transaction customer report" },
        { path: "/new-transaction-vendor-report", title: "New transaction vendor report" },
        { path: "/idle-company-report", title: "Idle company report" },
        { path: "/assignet-company-report", title: "Assignet company report" },
        { path: "/company-activity-report", title: "Company activity report" },
        { path: "/crm-action-report", title: "CRM action report" }
      ]
    }
  },
  computed: {
    activeBarHeight () {
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.$route.path.indexOf(this.tabs[i].path) > 0) {
          return i * 40
        }
      }
      return 0
    }
  },
  methods: {
    goPath (path) {
      this.$router.replace(`/customer/report${path}`)
    }
  }
}
</script>

<style lang="scss">
#customer-report {
  background-color: #fff;
}
</style>
